/**
 * Created by Pawel Grzyb 01.04.2018
 *
 * Bottom header menu.
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-header-bottom',
  templateUrl: './menu-header-bottom.component.html',
  styleUrls: ['./menu-header-bottom.component.css']
})
export class MenuHeaderBottomComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
